












































import { Component, Vue } from 'vue-property-decorator';
import CodeInput from '@/components/codeInput/codeInput.vue';
import { joinCourseByCode, getEnrollState } from '@/apis/courseList/courseList';
import { UserInfo } from '@/interfaces/vuexStateInterface';

  @Component({ components: { CodeInput } })
export default class JoinCourse extends Vue {
    private code: string = ''
    private value = '';
    showKeyboard = false;
    showOverlay = false;
    errorMsg = '';
    step: 1 | 2= 1;
    avatarUrl = '';
    userName = '';
    courseId = '';
    courseName = '';
    step2message = '';
    step2status = 100
    get userInfo(): UserInfo {
      return this.$store.getters.getUserInfo;
    }
    mounted() {
      window.localStorage.removeItem('currentLocation');
      // this.avatarUrl = this.userInfo.avatar || '';
      // this.userName = this.userInfo.username || '';
      this.$router.onReady(() => {
        this.code = this.$route.query.code as string;
        if (this.code !== 'undefined' && this.code) {
          this.codeSuccess(this.code, 'qrAdd');
        }
      })

      this.$setNavInfo({
        backConfig: () => {
          this.$router.push('/ktpCourse');
        }
      })
    }

    goCourse() {
      // todo 跳转到jc到课程详情页面
      window.sessionStorage.setItem('courseId',this.courseId)
      this.$router.push(`/courseHome?courseId=${this.courseId}&courseRole=0`);
    }
    backToCourseList() {
      this.$router.push('/ktpCourse')
    }

    gotoAttest() {
      this.$router.push('/myAllSetting?detail=myMechanism')
    }

    codeSuccess(param: string, type?: 'qrAdd') {
      this.errorMsg = '';
      this.showOverlay = true;
      joinCourseByCode(param)
        .then((res:any) => {
          this.courseName = res.coursename as string;
          this.courseId = res.courseid as string;
          this.avatarUrl = res.teacher.avatar // 加课成功后显示老师的头像
          this.userName = res.teacher.username // 加课成功后显示老师的名字
          this.step = 2;
          this.step2message = res.message;
          this.step2status = res.join;
          if(res.join ==102){
            this.step2status=101;
          }else if(res.join ==103) {
            this.step2status = 102;
          } else if(res.join === 105) {
            this.goCourse()
          } else if(res.join === 110) {
            this.$router.push({
              path: '/studentEnrollCourseDetail',
              query: {
                code: param
              }
            })
          }
          this.showOverlay = false;
        })
        .catch(e => {
          if (type && type === 'qrAdd') {
            this.step = 2;
            this.step2status = 101;
            this.step2message = e.message as string;
          }
          this.errorMsg = e.message as string;
          this.showOverlay = false;
        });
    }
}
